module.exports = (parcelRequire.load("6tza8")).then(() => parcelRequire('dndxI'));